module.exports = __webpack_public_path__ + "static/img/my-afterSale.2a0c5b59.png";